import React from 'react';
import {HeaderColumn, Row} from '@vidazoo/ui-kit';
import {ChartEditModel} from '../../../../modules/charts/item/edit/model/ChartEditModel.mdl';
import {observer} from 'mobx-react';
import {ChartCreateModel} from '../../../../modules/charts/item/create/model/ChartCreateModel.mdl';

export interface IDiffTableChartHeaderProps {
    appearance?: 'default' | 'classic';
    model: ChartEditModel | ChartCreateModel;
}

function DiffTableChartHeader({model, appearance}: IDiffTableChartHeaderProps) {
    const item = model.maskItems.at(0);

    return (
        <Row>
            {model.tableColumns.map((col) => <HeaderColumn appearance={appearance} disableNowrap key={col.key} colKey={col.key}/>)}
        </Row>
    )
}

export default observer(DiffTableChartHeader);
